import { IBasicFile } from '@sdk/contracts';

export const getFileDownloadInfo = (file: IBasicFile) => {
  const isVideo = typeof file.mimetype === 'string' && file.mimetype.startsWith('video/');

  const inferExtensionFromMime = () => {
    if (!file?.mimetype) return '';
    if (isVideo) return 'mp4';
    const parts = file.mimetype.split('/');
    return parts[1] || '';
  };

  const ensureExtension = (name: string, extension: string) => {
    if (!extension) return name;
    const lower = name.toLowerCase();
    const ext = `.${extension.toLowerCase()}`;
    return lower.endsWith(ext) ? name : `${name}${ext}`;
  };

  let urlToDownload = file.url;
  if (isVideo && file.url) {
    try {
      const u = new URL(file.url);
      u.searchParams.set('download', '1');
      urlToDownload = u.toString();
    } catch {
      urlToDownload = `${file.url}${file.url.includes('?') ? '&' : '?'}download=1`;
    }
  }

  const extension = inferExtensionFromMime();
  const filename = ensureExtension(file.name, extension);

  return { urlToDownload, filename };
};
